import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/icons/NoResults.svg'


const _hoisted_1 = { class: "wrapper-events" }
const _hoisted_2 = {
  key: 0,
  class: "wrapper-empty"
}
const _hoisted_3 = { class: "create-event" }
const _hoisted_4 = {
  key: 1,
  class: "event-full"
}
const _hoisted_5 = { class: "above-table-event" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "info-event" }
const _hoisted_9 = { class: "light" }
const _hoisted_10 = { class: "light" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = ["checked", "disabled", "onChange"]
const _hoisted_13 = {
  key: 1,
  class: "wrapper-empty-guests"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalCreateEditEvent = _resolveComponent("ModalCreateEditEvent")!
  const _component_ModalConfirmation = _resolveComponent("ModalConfirmation")!
  const _component_StandardButton = _resolveComponent("StandardButton")!
  const _component_Searcher = _resolveComponent("Searcher")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createVNode(_component_ModalCreateEditEvent, {
      event: _ctx.event,
      onClose: _ctx.closeInformationEventModal,
      onCreate: _ctx.createEventTransaction,
      onEdit: _ctx.editEventTransaction
    }, null, 8, ["event", "onClose", "onCreate", "onEdit"]), [
      [_vShow, _ctx.modalInfoEvent]
    ]),
    _withDirectives(_createVNode(_component_ModalConfirmation, {
      message: _ctx.confirmMessage,
      onAccept: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeConfirmModalAsync(_ctx.deleteEventTransaction))),
      onDeny: _ctx.closeConfirmModalAsync
    }, null, 8, ["message", "onDeny"]), [
      [_vShow, _ctx.showConfirmModal]
    ]),
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.event)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _cache[5] || (_cache[5] = _createElementVNode("p", null, "Eventos", -1)),
              _createVNode(_component_StandardButton, {
                buttonLabel: 'Crear evento',
                onClick: _ctx.createNewEvent
              }, null, 8, ["onClick"])
            ]),
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "empty" }, [
              _createElementVNode("img", {
                src: _imports_0,
                alt: "Sin resultados",
                class: "icon"
              }),
              _createElementVNode("p", { class: "text-empty" }, "No hay eventos creados")
            ], -1))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("p", _hoisted_6, "Eventos - " + _toDisplayString(_ctx.event.name), 1),
              _createElementVNode("a", {
                href: _ctx.route,
                class: "wrapper-button"
              }, [
                _createVNode(_component_StandardButton, {
                  buttonLabel: 'Descargar excel',
                  class: "button"
                })
              ], 8, _hoisted_7),
              _createVNode(_component_StandardButton, {
                buttonLabel: 'Editar evento',
                class: "add-guest",
                onClick: _ctx.editEvent,
                type: 'Edit'
              }, null, 8, ["onClick"]),
              _createVNode(_component_StandardButton, {
                buttonLabel: 'Eliminar evento',
                class: "delete-event",
                onClick: _ctx.openConfirmDeleteModal,
                type: 'Delete'
              }, null, 8, ["onClick"]),
              _createVNode(_component_Searcher, {
                search: _ctx.query,
                "onUpdate:search": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.query) = $event)),
                isDisabled: false,
                placeholder: "Busca por cliente (código o nombre) o invitado (documento o nombres)...",
                class: "searcher"
              }, null, 8, ["search"]),
              _createVNode(_component_StandardButton, {
                buttonLabel: 'Todos los invitados',
                isFilter: true,
                class: "filter1",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeFilterState(0)))
              }),
              _createVNode(_component_StandardButton, {
                buttonLabel: 'Registrados',
                isFilter: true,
                class: "filter2",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeFilterState(2)))
              }),
              _createVNode(_component_StandardButton, {
                buttonLabel: 'Sin registrar',
                isFilter: true,
                class: "filter3",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeFilterState(1)))
              })
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[7] || (_cache[7] = _createElementVNode("p", { class: "yellow" }, "Fecha máxima de registro:", -1)),
              _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.formatDate(_ctx.event.lastDate)), 1),
              _cache[8] || (_cache[8] = _createElementVNode("p", { class: "yellow space" }, "Máximo de invitados por cliente:", -1)),
              _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.event.maxInvites), 1)
            ]),
            (_ctx.filteredGuests.length > 0)
              ? (_openBlock(), _createElementBlock("table", _hoisted_11, [
                  _cache[9] || (_cache[9] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, "Cod. cliente"),
                      _createElementVNode("th", null, "Cliente"),
                      _createElementVNode("th", null, "Tipo doc."),
                      _createElementVNode("th", null, "No. documento"),
                      _createElementVNode("th", null, "Nombres"),
                      _createElementVNode("th", null, "Cargo"),
                      _createElementVNode("th", null, "Registrado")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredGuests, (guest) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: guest.document
                      }, [
                        _createElementVNode("td", null, _toDisplayString(guest.clientCode), 1),
                        _createElementVNode("td", null, _toDisplayString(guest.clientName), 1),
                        _createElementVNode("td", null, _toDisplayString(guest.documentType), 1),
                        _createElementVNode("td", null, _toDisplayString(guest.document), 1),
                        _createElementVNode("td", null, _toDisplayString(guest.guestName), 1),
                        _createElementVNode("td", null, _toDisplayString(guest.position), 1),
                        _createElementVNode("td", null, [
                          _createElementVNode("input", {
                            type: "checkbox",
                            class: "check",
                            checked: _ctx.isRegistered(guest),
                            disabled: _ctx.isRegistered(guest),
                            onChange: ($event: any) => (_ctx.checkGuestTransaction(guest))
                          }, null, 40, _hoisted_12)
                        ])
                      ]))
                    }), 128))
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_13, [...(_cache[10] || (_cache[10] = [
                  _createElementVNode("div", { class: "empty-guests" }, [
                    _createElementVNode("img", {
                      src: _imports_0,
                      alt: "Sin resultados",
                      class: "icon"
                    }),
                    _createElementVNode("p", { class: "text-empty" }, "No hay invitados")
                  ], -1)
                ]))]))
          ]))
    ])
  ], 64))
}